import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';
import ca from './locales/ca.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import ru from './locales/ru.json';
import ja from './locales/ja.json';
import sv from './locales/sv.json';
import nb from './locales/nb.json';
import fi from './locales/fi.json';

const resources = {
  es: { translation: es },
  en: { translation: en },
  ca: { translation: ca },
  fr: { translation: fr },
  de: { translation: de },
  pt: { translation: pt },
  zh: { translation: zh },
  ru: { translation: ru },
  ja: { translation: ja },
  sv: { translation: sv },
  nb: { translation: nb },
  fi: { translation: fi },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Fallback a inglés
    debug: false,
    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    // Normalizar códigos de idioma (ej: "ca-ES" -> "ca")
    load: 'languageOnly',
  });

export default i18n;

